import React, { useEffect, useState } from 'react';
import Loading from "../../elements/Loading";
import { LanguageService } from '../../../services/LanguageService'
import { ReactComponent as TermsuserSVG } from '../../../assets/img/general/terms.svg';
import { useDispatch, useSelector } from 'react-redux';
import { legalAgreement } from '../../../actions/account/AccountAction';
import { endSession, logout, playerDataReset } from '../../../actions/UserActions';
import ReactDOM from 'react-dom'
import Utils from '../../../services/Utils';
import { matchPath, useHistory } from "react-router"
import { RoutePath } from '../../../constants/SitePaths';

const CyprosTermsModal = () => {
    const agreementStartDate = useSelector(state => state.settings.agreementStartDate)
    const acceptedAgreementDate = useSelector(state => state.user.playerData?.player?.acceptedAgreementDate)
    const translations = useSelector(state => state.translations);
    const [loading, setLoading] = useState(false);
    const [openPopup, setPopupVisibility] = useState(true);
    const promptLimits = useSelector(state => state.user?.playerData?.player?.promptLimits || {});
    const { promptOnLogin: setUpLimits } = useSelector((state) => state.settings?.features) || {};

    const enableEmailOrMobileVerifyOnLogin = useSelector(state => state.settings.enableEmailOrMobileVerifyOnLogin);
    const isEmailVerified = useSelector(state => state.user.playerData.player?.isEmailVerified)
    const isMobileNumberVerified = useSelector(state => state.user.playerData.player?.isMobileNumberVerified);
    const history = useHistory();
    const dispatch = useDispatch();
    const [openLimitsPopup, setOpenLimitsPopup] = useState(false);

    useEffect(() => {
        if (Object.keys(promptLimits).length) {
            setOpenLimitsPopup(false)
            const result = Object.fromEntries(
                Object.keys(promptLimits).map(item => [
                    item,
                    !Utils.containsTruthyValue(promptLimits[item], ['isCalendarBase'])
                ])
            );
            if (result && setUpLimits && Object.keys(result).length && Object.keys(setUpLimits).length) {
                Object.keys(result).find((key) => {
                    if (result[key] && setUpLimits[key + 'Limit']) {
                        setOpenLimitsPopup(true)
                    }
                })
            }
        }
    }, [JSON.stringify(promptLimits)])

    const matchRules = matchPath(history.location.pathname, {
        path: `/:lang?${RoutePath.RULES}${RoutePath.POPUP_SUFFIX}`,
        exact: true,
        strict: false
    });

    const matchGameInfo = matchPath(history.location.pathname, {
        path: `/:lang?${RoutePath.RULES_ALTERNATIVE}${RoutePath.POPUP_SUFFIX}`,
        exact: false,
        strict: false
    });

    function cancelHandler() {
        dispatch(legalAgreement({ accepted: false }));
        setTimeout(() => {
            dispatch(logout());
            dispatch(playerDataReset());
            endSession(true, true);
        }, 50);
    }

    function submitHandler() {
        setLoading(true)
        dispatch(legalAgreement({ accepted: true })).then(result => {
            if (result) {
                setPopupVisibility(false);
            }
            setLoading(false);
        });
    }
    if ((matchRules && matchRules?.url.indexOf('/popup/') <= 0) || (matchGameInfo && matchGameInfo?.url.indexOf('/popup/') <= 0)) {
        return <></>
    }

    if (enableEmailOrMobileVerifyOnLogin && (!isEmailVerified || !isMobileNumberVerified)) {
        return <></>
    }
    
    if (Object.keys(promptLimits).length && openLimitsPopup && Utils.objectContainTrue(setUpLimits)) {
        return <></>
    }

    return typeof agreementStartDate === 'string' && openPopup && new Date(acceptedAgreementDate).getTime() < new Date(agreementStartDate).getTime() && agreementStartDate ?
        ReactDOM.createPortal(
            <div className='tb--modal-lvl1 tb--modal-terms'>
                <div className='tb--modal-lvl2'>
                    <div className='tb--modal-lvl3 tb--rel'>
                        <div className="tb--modal-popup tb-terms-modal tb-password-modal tb--flex tb--flex-col ">
                            <div className="tb--modal-header tb--flex tb--align-center tb--justify-end tb--pr-12">
                                <span className="tb--modal-header-txt tb--text_upercase tb--f-14 tb--flex-grow tb--ellipsis">{LanguageService.getTranslation('termsAndConditionsText')}</span>
                            </div>
                            <div className="tb--modal-body tb--flex tb--flex-col tb--flex-grow">
                                <form action="" method="" className="tb--body-panel tb--flex tb--flex-col tb--flex-grow">
                                    <div className="tb--modal-body-top tb--flex-grow">
                                        <div className="tb--modal-image">
                                            <TermsuserSVG />
                                        </div>
                                        <h4 className="tb--modal__text tb--mb-24">{LanguageService.getTranslation('termsAndConditionsText1')}</h4>
                                        <div className="tb--modal__terms tb--mb-24" dangerouslySetInnerHTML={{ __html: LanguageService.getTranslation('termsAndConditionsText2') }}></div>
                                    </div>
                                    <div className='tb--flex tb--gap-16'>
                                        <input className={`tb--btn tb--btn-text tb--btn-secondary tb--w_50  round-border`}
                                            type="button"
                                            onClick={cancelHandler}
                                            value={LanguageService.getTranslation('declineButton')} />
                                        {loading ? <Loading main={true} className={`tb--input-loader tb--btn tb--btn-text tb--shadow tb--w_50  round-border`} />
                                            : <input className={`tb--btn tb--btn-text tb--btn-ternary tb--w_50  round-border`}
                                                type="button"
                                                onClick={submitHandler}
                                                value={LanguageService.getTranslation('acceptButton')} />}

                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>,
            document.getElementById('modal-root')
        ) : <></>
}

export default CyprosTermsModal;
